import { render, staticRenderFns } from "./MultiplePieCharts.vue?vue&type=template&id=3b5d82ac&scoped=true"
import script from "./MultiplePieCharts.vue?vue&type=script&lang=js"
export * from "./MultiplePieCharts.vue?vue&type=script&lang=js"
import style0 from "./MultiplePieCharts.vue?vue&type=style&index=0&id=3b5d82ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d82ac",
  null
  
)

export default component.exports